// Потенциально перейти на lite версию
import exifr from 'exifr/dist/full.esm';
import { extInfo } from 'lib/extInfo';
import { exifDatesPriority } from 'reactApp/appHelpers/featuresHelpers/features/imageExif';
import { getExtension } from 'reactApp/modules/file/helpers/getExtention';
import { createDwhSender } from 'reactApp/utils/ga';

const sendUploaderDwh = createDwhSender('uploader');

interface ExifRDates {
    DateTimeOriginal: Date;
    CreateDate: Date;
    ModifyDate: Date;
}

interface ExifDates {
    DateTimeOriginal: Date;
    DateTimeDigitized: Date;
    DateTime: Date;
}

export const hasExif = (file: File) => {
    const ext = getExtension(file.name);
    return extInfo.getExtsWithExif().includes(ext.toLowerCase());
};

const exifToExifR = {
    DateTimeOriginal: 'DateTimeOriginal',
    DateTimeDigitized: 'CreateDate',
    DateTime: 'ModifyDate',
} as const;

const mapExifToExifR = (exifDates: string[]): (keyof ExifRDates)[] => {
    return exifDates.map((date) => exifToExifR[date]);
};

const mapExifRToExif = (exifRDates: Partial<ExifRDates>): Partial<ExifDates> => ({
    DateTimeOriginal: exifRDates.DateTimeOriginal,
    DateTimeDigitized: exifRDates.CreateDate,
    DateTime: exifRDates.ModifyDate,
});

export const getFileExifMtime = async (file: File) => {
    try {
        /**
         * parse может вернуть undefined если не нашел ни один тег, поэтому добавляем || {}
         */
        const exifRDates: Partial<ExifRDates> = (await exifr.parse(file, mapExifToExifR(exifDatesPriority))) || {};

        /**
         * Библиотека переписывает оригинальные названия полей в exif:
         * - DateTime -> ModifyDate
         * - DateTimeDigitized -> CreateDate
         * - DateTimeOriginal -> DateTimeOriginal
         * поэтому мапаем обратно
         *
         * С назначениями и кодами полей можно ознакомится тут
         * @link https://exiv2.org/tags.html
         */
        const exifDates = mapExifRToExif(exifRDates);

        // Ищем дату из exif согласно приоритету
        const exifDateName = exifDatesPriority.find((dateName) => Boolean(exifDates[dateName]));
        const exifTimestampMS = exifDateName && exifDates[exifDateName] instanceof Date && exifDates[exifDateName].getTime();

        if (!exifTimestampMS) {
            sendUploaderDwh({
                action: 'no-exif',
                dwhData: {
                    extension: file.name.split('.')[1],
                },
            });

            return null;
        }

        sendUploaderDwh({
            action: 'exif-success',
            dwhData: {
                extension: file.name.split('.')[1],
                selectedExifField: exifDateName,
                exifFields: Object.keys(exifDates).join(','),
            },
        });

        return Math.floor(exifTimestampMS / 1000);
    } catch (error: any) {
        sendUploaderDwh({
            action: 'exif-error',
            dwhData: {
                message: error,
            },
        });

        return null;
    }
};
